import { defineComponent } from "vue";
import { Container } from "aurelia-dependency-injection";

import { IOpenOrder } from "../../vue-interfaces/i-plan-of-care";
import { ITypeaheadOptions } from "../../vue-interfaces/i-typeahead";
import { TaskService } from "../../../services/task.service";
import { ToastrService } from "../../../services/toastr.service";
import { formatDate } from "../../../common/vue-helpers/modifiers/value-modifier";
import { taskStatusNameColor } from "../../../common/vue-helpers/modifiers/task-status-color";

import FormatName from "../FormatName/FormatName.vue";
import TypeaheadInput from "../TypeaheadInput/TypeaheadInput.vue";

export default defineComponent({
    components: {
        FormatName,
        TypeaheadInput
    },
    props: {
        order: {
            type: Object,
            default: {} as IOpenOrder
        },
        selectedOrder: {
            type: Object,
            default: {} as IOpenOrder
        },
        getPhysicians: { type: Function, default: null },
        openOrder: { type: Function, default: null },
        selectOrder: { type: Function, default: null }
    },
    data() {
        return {
            showEditPhysician: false,
            isUpdateInProgress: false,
            selectedPhysician: null as ITypeaheadOptions,
            _taskService: null,
            _toastrService: null,
            formatDate,
            taskStatusNameColor
        };
    },
    watch: {
        order() {
            if (!!this.order) {
                if (!!this.order.PhysicianFirstName) {
                    this.order.PhysicianFirstName = this.order.PhysicianFirstName.toLocaleLowerCase();
                }
                if (!!this.order.PhysicianLastName) {
                    this.order.PhysicianLastName = this.order.PhysicianLastName.toLocaleLowerCase();
                }
            }
        }
    },
    created() {
        this._taskService = Container.instance.get(TaskService);
        this._toastrService = Container.instance.get(ToastrService);
    },
    methods: {
        async getPhysicianList(filter: string, limit: number) {
            return await this.getPhysicians({
                filter,
                limit
            });
        },
        selectedPhysicianChanged(data: ITypeaheadOptions) {
            this.selectedPhysician = data;
        },
        openAddPhysicianToOrder() {
            this.showEditPhysician = true;
        },
        async addPhysicianToOrder() {
            try {
                this.closeAddPhysicianToOrder();
                this.isUpdateInProgress = true;
                // Test this endpoint
                await this._taskService.updateOrder(this.order.OrderId, {
                    physicianId: this.selectedPhysician.value,
                    physicianName: this.selectedPhysician.name
                });
                this.order.OrderStatus = "Saved";
                this.order.PhysicianFirstName = this.selectedPhysician.name.split(" ")[1];
                this.order.PhysicianLastName = this.selectedPhysician.name.split(" ")[0];
                this.selectedPhysician = null;
                this.isUpdateInProgress = false;
            } catch (e) {
                this.isUpdateInProgress = false;
                this.openAddPhysicianToOrder();
                console.error(e);
                this._toastrService.error({
                    title: "Error - Add Physician",
                    message: `There was a problem while adding the physician to the order. Please try again.`
                });
            }
        },
        closeAddPhysicianToOrder() {
            this.showEditPhysician = false;
        }
    }
});
